<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>QUARZKOMPOSIT</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Quarzkomposit besteht meist aus über 90 Prozent Quarz das mit einem Kunstharz und Farbstoffen zu einem sehr widerstandsfähigem Material zusammengefügt wird. Sie besitzen eine hohe Abriebfestigkeit, Hitzebeständigkeit und sind durch die glatte, verdichtete Oberfläche nicht porös, wodurch ein Eindringen von Flüssigkeiten verhindert wird.  Die Härte entspricht ähnlich der eines mittleren Granit wodurch sich eine Vielzahl an Gestaltungs- und Einsatzmöglichkeiten bieten. </p>
        <hr>
        <h2>Qualität von renommierten Herstellern</h2>
        <p>Vor allem als Küchenarbeitsplatte, Waschtischplatte Fensterbänke und Abdeckungen sind Quarzkomposite besonders geeignet.<br><br>Bei uns erhalten Sie unter anderem Quarzkomposite von renommierten Firmen wie Ceasarstone, Cosentino (Silestone), Diresco oder Compac. Aber auch innovative und neuartige Materialien wie z. B. Dekton, das eine Mischung aus Keramik, Glas und Quarz ist, bieten wir an.</p>
        <hr>
        <div class="image-row">
          <div class="image-row-item high"><a href="http://www.caesarstone.de/Pages/visualiser.aspx" target="_blank"><img src="https://marmor-kunze.de/static/images/material/logo_caesarstone.jpg"></a></div>
          <div class="image-row-item high"><a href="https://www.cosentino.com/de/farben/" target="_blank"><img src="https://marmor-kunze.de/static/images/material/logo_cosentino.jpg"></a></div>
          <div class="image-row-item high"><a href="http://www.diresco.be/de/diresco-stone-3#colors" target="_blank"><img src="https://marmor-kunze.de/static/images/material/logo_diresco.jpg"></a></div>
          <div class="image-row-item high"><a href="http://de.compac.es/quarz/" target="_blank"><img src="https://marmor-kunze.de/static/images/material/logo_compac.jpg"></a></div>
        </div>
      </article>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Quarzkomposit',
  metaInfo: {
    title: 'Quarzkomposit',
    meta:[
      { vmid: 'description', name: 'description', content: "Quarzkomposit besteht meist aus über 90 Prozent Quarz das mit einem Kunstharz und Farbstoffen zu einem sehr widerstandsfähigem Material zusammengefügt wird."},
      { vmid: 'keywords', name: 'keywords', content: "Quarzkomposit, Silestone, Ceasarstone, Dekton, Naturstein, Natursteinhandel Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/material/quarzkomposit'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Quarzkomposit.vue